<template>
  <div class="flex sharing-v">
    <Header />
    <Step />
    <div class="form-area">
      <a-form id="accountLoginForm" :form="form" @submit="profileFormSubmit">
        <a-form-item label="考试类型">
          <a-row :gutter="10">
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
              <a-input placeholder="工作单位" value="正考" disabled />
            </a-col>
            <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
              <p class="form-tip" style="width: 100%; margin-left: 15px">
                以下内容为必填项，请如实填写
              </p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="10" :lg="6" :xl="6">
            <a-form-item label="身份类型">
              <a-radio-group
                v-decorator="[
                  'type',
                  { initialValue: userInfo.type ? userInfo.type : 1 },
                ]"
                @change="selectStudentType"
              >
                <a-radio :value="1">在职</a-radio>
                <a-radio :value="2">学生</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <a-form-item label="电子邮件">
              <a-input
                placeholder="电子邮件"
                v-decorator="[
                  'email',

                  {
                    rules: [
                      { required: true, message: '请输入电子邮件' },
                      {
                        pattern: !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                        message: '请输入正确的电子邮件',
                      },
                    ],
                    initialValue: userInfo.email,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-if="studentType == 1">
          <a-col :xs="24" :sm="12" :md="10" :lg="6" :xl="6">
            <a-form-item label="工作单位">
              <a-input
                placeholder="工作单位"
                v-decorator="[
                  'companyName',

                  {
                    rules: [{ required: true, message: '请填写工作单位' }],
                    initialValue: userInfo.companyName,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <a-form-item label="目前职位">
              <a-input
                placeholder="目前职位"
                v-decorator="[
                  'title',

                  {
                    rules: [{ required: true, message: '请填写目前职位' }],
                    initialValue: userInfo.title,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="10" :lg="6" :xl="6">
            <a-form-item label="毕业学校" v-if="studentType == 1">
              <a-input
                placeholder="毕业学校"
                v-decorator="[
                  'graduateSchool',

                  {
                    rules: [{ required: true, message: '请填写毕业学校' }],
                    initialValue: userInfo.graduateSchool,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="就读学校" v-else>
              <a-input
                placeholder="就读学校"
                v-decorator="[
                  'graduateSchool',

                  {
                    rules: [{ required: true, message: '请填写就读学校' }],
                    initialValue: userInfo.graduateSchool,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <a-form-item label="学历">
              <a-select
                v-decorator="[
                  'academicQualification',
                  {
                    rules: [{ required: true, message: '请填写学历' }],
                    initialValue: userInfo.academicQualification
                      ? String(userInfo.academicQualification)
                      : undefined,
                  },
                ]"
                placeholder="请选择学历"
              >
                <a-select-option value="1">高中及以下</a-select-option>
                <a-select-option value="2">专科</a-select-option>
                <a-select-option value="3">本科</a-select-option>
                <a-select-option value="4">硕士</a-select-option>
                <a-select-option value="5">博士</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col
            :xs="24"
            :sm="12"
            :md="10"
            :lg="6"
            :xl="6"
            v-if="studentType == 1"
          >
            <a-form-item label="毕业时间">
              <a-date-picker
                v-decorator="[
                  'graduateDate',

                  {
                    rules: [{ required: true, message: '毕业时间' }],
                    initialValue: userInfo.graduateDate
                      ? moment(userInfo.graduateDate, 'YYYY-MM-DD')
                      : moment('2020-01-01', 'YYYY-MM-DD'),
                  },
                ]"
                placeholder="毕业时间"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <a-form-item label="专业">
              <a-input
                placeholder="请选择专业"
                v-decorator="[
                  'major',

                  {
                    rules: [{ required: true, message: '请填写专业' }],
                    initialValue: userInfo.major,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :xs="24" :sm="12" :md="10" :lg="10" :xl="8">
            <a-form-item label="学历证明文件">
              <a-spin :spinning="spinning">
                <a-upload
                  name="avatar"
                  accept="image/*"
                  v-decorator="[
                    'degreeUrl',
                    {
                      getValueFromEvent: normFile,
                      initialValue: degreeUrl ? degreeUrl : '',
                      rules: [
                        { required: true, message: '请上传学历证明文件照' },
                      ],
                    },
                  ]"
                  action="3131"
                  :beforeUpload="beforeUpload"
                  @change="degreeHandleChange"
                  listType="picture-card"
                  class="certificate-uploader"
                  :showUploadList="false"
                >
                  <img
                    :src="
                      degreeUrl ? degreeUrl : require('@/assets/images/p2.png')
                    "
                    alt="certificate"
                  />
                  <div class="btn-plus flex sharing-v" v-if="!degreeUrl">
                    <a-icon
                      :type="loading1 ? 'loading' : 'plus'"
                      style="font-size: 24px; margin-bottom: 8px"
                    />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-spin>
            </a-form-item>
          </a-col>
          <a-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="10"
            :xl="8"
            v-if="studentType == 1"
          >
            <a-form-item label="工作证明文件">
              <a-spin :spinning="spinning1">
                <a-upload
                  name="avatar"
                  accept="image/*"
                  v-decorator="[
                    'employmentUrl',
                    {
                      getValueFromEvent: normFile,
                      initialValue: employmentUrl ? employmentUrl : '',
                    },
                  ]"
                  action="3131"
                  :beforeUpload="beforeUpload"
                  @change="employHandleChange"
                  listType="picture-card"
                  class="certificate-uploader"
                  :showUploadList="false"
                >
                  <img
                    :src="
                      employmentUrl
                        ? employmentUrl
                        : require('@/assets/images/p1.png')
                    "
                    alt="avatar"
                  />
                  <div class="btn-plus flex sharing-v" v-if="!employmentUrl">
                    <a-icon
                      :type="loading2 ? 'loading' : 'plus'"
                      style="font-size: 24px; margin-bottom: 8px"
                    />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-spin>
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item class="text-center">
          <!-- <a-checkbox
            v-decorator="['isAgree', 
          
                
          
          
             {rules: [
                      { required: true, message: '请上传学历证明文件照' },
                    ],
                      initialValue: true,
          valuePropName: 'checked',
                    }
        
            
            
            ]"
          
          >本人郑重承诺以上资料真实有效</a-checkbox>-->
          <a-checkbox-group
            v-decorator="[
              'checkbox-group',
              {
                initialValue: ['A'],
                rules: [{ required: true, message: '请勾选同意' }],
              },
            ]"
            style="width: 100%"
          >
            <a-checkbox value="A">本人郑重承诺以上资料真实有效</a-checkbox>
          </a-checkbox-group>
        </a-form-item>

        <a-form-item class="text-center">
          <a href="/authent">
            <a-button type="detault" style="margin-right: 20px"
              >上一步</a-button
            >
          </a>
          <a-button type="primary" html-type="submit">下一步</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsDataURL(img);
// }
// @ is an alias to /src
import Header from "../components/Header";
import Step from "../components/common/step";
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("apply");

export default {
  name: "Login",
  components: {
    Header,
    Step
  },
  data() {
    return {
      form: this.$form.createForm(this),
      studentType: 1,
      loading1: false,
      loading2: false,
      spinning: false,
      spinning1: false,
      degreeUrl: "",
      employmentUrl: "",
      userInfo: {}
    };
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
    this.getStudentInfo({
      orderCode: userInfo.orderCode,
      userCode: userInfo.userCode,
      examCode: userInfo.examCode,
    }).then(res => {
      let studentInfo = res.data;
      if (studentInfo.status) {
        this.degreeUrl = studentInfo.data.academicQualificationURL;
        this.employmentUrl = studentInfo.data.jobURL == 'null' ? "" : studentInfo.data.jobURL;
        this.userInfo = studentInfo.data;
        this.studentType = this.userInfo.type || 1
      } else {
        this.userInfo = userInfo;
      }
    });
  },
  methods: {
    moment,
    ...mapActions([
      "getStudentInfo",
      "addStudentAction",
      "updateStudentAction",
      "getPicUrl"
    ]),
    profileFormSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        console.log(values);
        if (!err) {
          let userInfo = JSON.parse(localStorage.getItem("studentInfo"));
          values.academicQualificationURL = this.degreeUrl;
          if (this.studentType == 1) {
            values.jobURL = this.employmentUrl;
            values.graduateDate = values.graduateDate.format("YYYY-MM-DD");
          }
          values.enrollInfoId = userInfo.enrollInfoId;
          values.examCode = userInfo.examCode;
          values.updateType = 2;
          delete values.isAgree;

          let formData = new FormData();
          // fields 是表單內容，將它 append 到 formData
          Object.keys(values).map(item => {
            formData.append(item, values[item]);
          });
          this.updateStudentAction(formData).then(res => {
            this.applyStatusJudge(res.data);
            // if (res.data.status == 2000) {
            //   this.$router.push("/area");
            // }
          });
        }
      });
    },
    selectStudentType(e) {
      this.studentType = e.target.value;

    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("文件格式为jpg、png!");
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("图片大小不大于5M!");
      }
      return isJPG && isLt2M;
    },
    degreeHandleChange(info) {
      if (info.file.status === "uploading") {
        this.loading1 = true;
        this.spinning = true
        return;
      } else {
        // getBase64(info.file.originFileObj, imageUrl => {
        //   this.degreeUrl = imageUrl;
        this.loading1 = false;
        // });
        let formData = new FormData();
        formData.append("file", info.file.originFileObj);
        this.getPicUrl(formData).then(res => {
          if (res.data.status == 2000) {
            this.degreeUrl = res.data.data;
            this.spinning = false
          }
        });
      }
    },
    employHandleChange(info) {
      if (info.file.status === "uploading") {
        this.loading2 = true;
        this.spinning1 = true
        return;
      } else {
        // getBase64(info.file.originFileObj, imageUrl => {
        //   this.employmentUrl = imageUrl;
        this.loading2 = false;
        // });
        let formData = new FormData();
        formData.append("file", info.file.originFileObj);
        this.getPicUrl(formData).then(res => {
          if (res.data.status == 2000) {
            this.employmentUrl = res.data.data;
            this.spinning1 = false
          }

        });
      }
    },
    applyStatusJudge(data) {
      if (data.status == 2000) {
        this.$router.push("/area");
      } else {
        this.$warning({
          title: data.message,
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
          onOk() { },
          onCancel() { }
        });
      }
    }
  }
};
</script>

<style scoped>
.row-item {
  margin-top: 15px;
}
.form-title {
  margin-bottom: 15px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.form-tip {
  margin-bottom: 0;
  text-emphasis: none;
  font-size: 13px;
  color: #d51d20;
}
.form-item {
  align-items: flex-start;
}
.papers-box {
  justify-content: flex-start;
}
.certificate-cover {
  width: 100%;
}
.next-box {
  margin-top: 30px;
  justify-content: center;
}
</style>